import React from "react";
import InputFactory from "../../../components/InputFactory";

function DialogReset({ onChangeField, clickSubmit, clickClose }) {
  function onChange(value, field) {
    onChangeField(value, field);
  }
  return (
    <div className=" p-4 rounded" style={{ maxWidth: "450px", margin: "auto" }}>
      <div
        className="d-flex align-items-center mb-3"
        style={{ color: "#d18237" }}
      >
        <div className="bg-light p-2 rounded-circle">
          <i className="bi bi-shield-lock fs-4"></i>
        </div>
        <h5 className="fw-bold ms-2">Change Password</h5>
      </div>

      {/* New Password Field */}
      <div className="col-md-12">
        <label className="form-label fs-sm">New Password</label>
        <div className="input-group">
          <InputFactory
            className="form-control"
            type="Password"
            field="newPassword"
            placeholder="Enter Password"
            onChange={(value, field) => onChange(value, field)}
          />
        </div>
      </div>

      <div className="col-md-12">
        <label className="form-label fs-sm">Confirm Password</label>
        <div className="input-group">
          <InputFactory
            className="form-control"
            type="Password"
            field="confirmNewPassword"
            placeholder="Enter Password"
            onChange={(value, field) => onChange(value, field)}
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-center mt-3">
        <button
          className="btn text-white px-4 me-2"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickSubmit()}
        >
          Confirm
        </button>
        <button
          className="btn px-4"
          onClick={() => clickClose()}
          style={{ backgroundColor: "#bdbdbd" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DialogReset;
